import { itemDeleteApi } from "../../api/item/itemDeleteApi"

type PayloadShape = Parameters<typeof itemDeleteApi>[0]

export async function itemDeleteService(payload: PayloadShape, token: string) {
	return await itemDeleteApi(payload, token)
}
